export const formSubmitValueMapper = (data = {}) => ({
  id_work_order: data.id_work_order,
});
